module.exports = __webpack_public_path__ + "static/DIY_Wishmasflower-fec3e29c43c1ef2e5d77809d622af318.jpg";